import React from "react";
import { CONTACT } from "@/config/contact";
import { MessageCircle } from "lucide-react";

export default function WhatsAppBubble() {
  return (
    <a
      href={CONTACT.whatsappUrl}
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-bubble"
      aria-label="Falar com a Zélia via WhatsApp"
      className="fixed bottom-6 right-6 z-40 group inline-flex items-center gap-2 rounded-full bg-[#25D366] pl-4 pr-5 py-3 text-white shadow-[0_12px_40px_rgba(37,211,102,0.35)] hover:shadow-[0_18px_50px_rgba(37,211,102,0.5)] transition-all duration-300 hover:-translate-y-0.5"
    >
      <MessageCircle className="h-5 w-5" />
      <span className="hidden sm:inline text-sm font-medium">WhatsApp</span>
      <span className="pointer-events-none absolute inset-0 rounded-full ring-4 ring-[#25D366]/20 animate-ping opacity-60" />
    </a>
  );
}
